/* eslint-disable react/no-unused-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent } from 'react';
import { ICON_CHECK, Symbol } from '@doveit/lego';

import * as styles from './SelectableItem.style';

export interface SelectableItemProps {
  id: string | number,
  noPad?: boolean,
  icon?: string,
  title: string,
  label?: string,
  active?: boolean,
  onItemClick?: VoidFunction,
  data?: any,
}

const SelectableItem: FunctionComponent<SelectableItemProps> = ({
  title,
  label,
  icon,
  active,
  noPad,
  onItemClick,
}) => (
  <div
    onClick={onItemClick}
    $active={active}
    $noPad={noPad}
    css={styles.base}
  >
    {
      // Keep this condition to render empty icon
      icon !== undefined && icon !== null && (
        <div
          css={styles.icon}
        >
          <Symbol
            path={icon}
            size={16}
          />
        </div>
      )
    }
    <div css={styles.info}>
      <span dangerouslySetInnerHTML={{ __html: title }} />
      {label && (
        <span css={styles.label}>{label}</span>
      )}
      {active && (
        <div css={styles.selectedIcon}>
          <Symbol
            path={ICON_CHECK}
            size={16}
          />
        </div>
      )}
    </div>
  </div>
);

export default SelectableItem;
